import { z } from "zod/v4"

export const vendorBalanceListSchema = z.object({
  vendorSite: z.number(),
  vendorName: z.string(),
  userId: z.string(),
  vendorBalance: z.number()
})

export const queryPlayerBalanceDetailResponseSchema = z.object({
  mainBalanceList: z.tuple([
    z.object({
      mainBalance: z.number(),
      exposure: z.number()
    })
  ]),
  // Left out when the player has no vendor balance to show
  vendorBalanceList: z.array(vendorBalanceListSchema).optional()
})

export const queryPlayerInfoResponseSchema = z.object({
  accountSuspended: z.number(),
  accountSysSuspended: z.number(),
  betCredit: z.number(),
  coinPreference: z.string(),
  customizeStake: z.string().nullable(),
  oneClickBetStake: z.string().nullable(),
  userCoin: z.number(),
  creditAllocated: z.number(),
  enableForecastWithCommission: z.number(),
  minBet: z.number(),
  // Sent only while ENABLE_SHOW_DECRYPT_USERID is on and the STREAMING_MANAGER setting exists
  s: z.number().optional(),
  totalExposure: z.number(),
  vendorQuantity: z.number()
})

// Sent by /queryAccountPage; the website info store keeps it next to the init info.
export const accountPageSchema = z.object({
  // Account.lastName on the OW site, userID elsewhere
  accountName: z.string(),
  accountTimeZone: z.string(),
  labelList: z.array(
    z.object({
      label: z.string()
    })
  ),
  hasLogout: z.boolean(),
  titleName: z.string(),
  // null when hasLogout is false
  logoutWording: z.string().nullable(),
  isDemoAccounts: z.boolean()
})

// getFingerprintProPublicKey's success body
export const fingerprintProPublicKeyDataSchema = z.object({
  publicKey: z.string(),
  createdDate: z.number(),
  siteId: z.number(),
  status: z.string(),
  userId: z.string(),
  // translated through the language bundle
  status_msg: z.string(),
  // Backend-controlled switch (SACRIC-1262): true routes Fingerprint traffic
  // through our proxy endpoint; false lets the agent use its native default
  // Fingerprint hosts. Absent during rollout is treated as false (proxy off).
  proxyEnabled: z.boolean()
})

export const queryAccountPageResponseSchema = z.object({
  accountPage: accountPageSchema,
  status: z.string(),
  status_msg: z.string()
})
